import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class MarketingService {
  private api = inject(ApiService);

  getAll(year: number, month: number) { return this.api.get(`/marketing/all/${year}/${month}`); }
  getAllByType(year: number, month: number, type: string, divNumber: number) {
    return this.api.get(`/marketing/${year}/${month}/${type}/${divNumber}`);
  }
  getFlyer(month: string) { return this.api.get(`/flyer/${month}`); }
  getPromotionList(month: string) { return this.api.get(`/promotion/${month}`); }
  upsertPromotion(json: any) { return this.api.post('/promotion', json); }
  upsertPersonal(json: any) { return this.api.post('/personal', json); }
  updatePictureRotate(json: any) { return this.api.post('/marketing/picture/rotate', json); }
  removePicture(json: any) { return this.api.post('/marketing/picture/remove', json); }

  async uploadPicture(id: number, pictureId: number, fileData: FormData): Promise<any> {
    return this.api.post(`/marketing/${id}/picture/${pictureId}`, fileData);
  }
}
